import { useQuery } from 'react-query'
import { t } from 'ttag'
import styled from 'styled-components'

import { Heading } from '@h2/components/typography/heading'
import { Flex } from '@h2/components/layout/flex'
import { api } from '@h2/api'
import { PB97T } from '@h2/components/colors'
import { Skeleton } from '@h2/components/loading/skeleton'
import { features } from '@h2/components/media'

import { RecommendationCard } from './recommendationCard'

const Wrap = styled.div`
  background-color: ${PB97T};
  padding: 15px 25px;
  border-radius: 5px;

  > div {
    overflow-x: scroll;
  }
`
const ConditionalFlex = styled(Flex)`
  @media (${features.maxWidth.desktop}) {
    flex-wrap: wrap;
  }
`
const Recommendations = () => {
  const { data, isFetching } = useQuery('recommendations', () => {
    return api.fetch('/recommendations', { method: 'GET' })
  })
  const items =
    data?.items.map((itm, idx) => {
      if (idx === 3 && data.promotions?.length > 0) {
        return data.promotions[0]
      }

      return itm
    }) || []
  const renderItems = () => {
    if (isFetching) {
      return new Array(4).fill().map((unusedVal, idx) => {
        return <Skeleton display="block" height="120px" key={`loader-${idx}`} />
      })
    }

    return items.map((rec, index) => (
      <RecommendationCard key={index} recommendation={rec} />
    ))
  }

  return (
    <Wrap>
      <Heading level="4" mb="15px">
        {t`Check out your recommendations`}
      </Heading>
      <ConditionalFlex alignItems="top" gap="15px" padding="5px">
        {renderItems()}
      </ConditionalFlex>
    </Wrap>
  )
}

export { Recommendations }
